<div class="page-head">
  <div>
    <p class="eyebrow">ค่าใช้จ่าย</p>
    <h1>ใบขอเบิก</h1>
    <p>ติดตามการตรวจ อนุมัติ และการจ่ายเงินจริง</p>
  </div>
  <button
    type="button"
    class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 active:scale-[0.98]"
    (click)="openExpenseModal()"
  >
    <lucide-icon name="Plus" [size]="17" /> สร้างใบขอเบิก
  </button>
</div>
<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  <p-table
    #expensesTable
    [value]="expenses()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="['code', 'title', 'requester', 'status']"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    [tableStyle]="{ 'min-width': '900px' }"
  >
    <ng-template #caption
      ><label class="relative block w-full max-w-md"
        ><lucide-icon
          name="Search"
          [size]="17"
          class="pointer-events-none absolute top-1/2 left-2 z-10 -translate-y-1/2 text-slate-400" /><input
          pInputText
          #expenseQuery
          class="h-11 w-full pr-3 text-sm placeholder:text-slate-400"
          style="padding-left: 2.75rem; border-radius: 0.5rem"
          placeholder="ค้นหาเลขที่ รายการ หรือผู้ขอเบิก"
          (input)="expensesTable.filterGlobal(expenseQuery.value, 'contains')" /></label
    ></ng-template>
    <ng-template #header
      ><tr>
        <th pSortableColumn="code">เลขที่ <p-sortIcon field="code" /></th>
        <th pSortableColumn="title">รายการ <p-sortIcon field="title" /></th>
        <th pSortableColumn="requester">ผู้ขอเบิก <p-sortIcon field="requester" /></th>
        <th pSortableColumn="amount">จำนวนเงิน <p-sortIcon field="amount" /></th>
        <th pSortableColumn="status">สถานะ <p-sortIcon field="status" /></th>
        <th pSortableColumn="createdAt">วันที่สร้าง <p-sortIcon field="createdAt" /></th>
        <th class="text-right">ดำเนินการ</th>
      </tr></ng-template
    >
    <ng-template #body let-row
      ><tr>
        <td>
          <strong>{{ row.code }}</strong>
        </td>
        <td>{{ row.title }}</td>
        <td>{{ row.requester }}</td>
        <td>{{ row.amount | number: '1.2-2' }} บาท</td>
        <td><app-status-badge [status]="row.status" /></td>
        <td>{{ row.createdAt | date: 'dd MMM yyyy' }}</td>
        <td>
          <div class="flex justify-end gap-2">
            <button
              type="button"
              class="tw-button rounded-lg border border-slate-200 bg-white p-2 text-slate-600 hover:bg-slate-50"
              title="ดูรายละเอียด"
              (click)="openExpenseDetail(row)"
            >
              <lucide-icon name="Eye" [size]="17" />
            </button>
          </div>
        </td></tr
    ></ng-template>
    <ng-template #emptymessage
      ><tr>
        <td colspan="7">
          <div class="empty">
            <h3>ไม่พบใบขอเบิก</h3>
            <p>ลองเปลี่ยนคำค้นหา</p>
          </div>
        </td>
      </tr></ng-template
    >
  </p-table>
</section>

@if (isExpenseModalOpen()) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="closeExpenseModal()"
  >
    <section
      class="my-auto w-full max-w-2xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-expense-title"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            ข้อมูลค่าใช้จ่าย
          </p>
          <h2 id="add-expense-title" class="m-0 text-xl font-bold text-slate-800">สร้างใบขอเบิก</h2>
        </div>
        <button
          type="button"
          class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          aria-label="ปิดหน้าต่าง"
          (click)="closeExpenseModal()"
        >
          <lucide-icon name="X" [size]="19" />
        </button>
      </div>
      <form [formGroup]="expenseForm" (ngSubmit)="saveExpense()">
        <div class="grid gap-x-6 gap-y-0 px-5 py-5 sm:grid-cols-2 sm:px-6">
          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
            ><span>เลข Booking <span class="text-red-500">*</span></span
            ><input
              pInputText
              class="h-11 w-full font-normal"
              formControlName="bookingCode"
              placeholder="เช่น BK-2026-000001"
            /><span class="min-h-4">
              @if (isInvalid('bookingCode')) {
                <small class="font-normal text-red-600">กรุณากรอกเลข Booking</small>
              }
            </span></label
          >
          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
            ><span>ประเภทค่าใช้จ่าย <span class="text-red-500">*</span></span
            ><p-select
              class="h-11 w-full font-normal"
              formControlName="expenseType"
              [options]="expenseTypeOptions"
              placeholder="เลือกประเภทค่าใช้จ่าย"
            /><span class="min-h-4">
              @if (isInvalid('expenseType')) {
                <small class="font-normal text-red-600">กรุณาเลือกประเภทค่าใช้จ่าย</small>
              }
            </span></label
          >
          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700 sm:col-span-2"
            ><span>รายการ <span class="text-red-500">*</span></span
            ><input
              pInputText
              class="h-11 w-full font-normal"
              formControlName="title"
              placeholder="ระบุรายการที่ต้องการขอเบิก"
            /><span class="min-h-4">
              @if (isInvalid('title')) {
                <small class="font-normal text-red-600">กรุณากรอกรายการ</small>
              }
            </span></label
          >
          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700 sm:col-span-2"
            ><span>จำนวนเงิน <span class="text-red-500">*</span></span
            ><p-inputnumber
              class="w-full font-normal"
              inputStyleClass="h-11 w-full"
              formControlName="amount"
              mode="currency"
              currency="THB"
              locale="th-TH"
              [min]="1"
              placeholder="0.00"
            /><span class="min-h-4">
              @if (isInvalid('amount')) {
                <small class="font-normal text-red-600">กรุณากรอกจำนวนเงินมากกว่า 0</small>
              }
            </span></label
          >
          <div class="grid content-start gap-1 text-sm font-semibold text-slate-700 sm:col-span-2">
            <span>แนบใบสั่งซื้อ <span class="text-red-500">*</span></span>
            <div class="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-4">
              <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
                <p-fileupload #purchaseOrderUpload mode="basic" name="purchaseOrder" chooseLabel="เลือกไฟล์" accept=".pdf,.jpg,.jpeg,.png" [maxFileSize]="5000000" [auto]="false" (onSelect)="selectPurchaseOrder($event)" (onClear)="purchaseOrderFileName.set('')" />
                <button type="button" class="tw-button inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-red-200 bg-white px-4 text-sm font-semibold text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40" [disabled]="!purchaseOrderUpload.files.length" (click)="purchaseOrderUpload.clear(); purchaseOrderFileName.set('')">
                  <lucide-icon name="X" [size]="16" aria-hidden="true" /> ยกเลิกไฟล์
                </button>
              </div>
              @if (purchaseOrderFileName()) { <p class="mt-2 mb-0 text-xs font-normal text-sky-700">{{ purchaseOrderFileName() }}</p> }
              <p class="mt-2 mb-0 text-xs font-normal text-slate-500">รองรับไฟล์ PDF, JPG และ PNG ขนาดไม่เกิน 5 MB</p>
            </div>
            @if (!purchaseOrderFileName() && expenseForm.touched) {
              <small class="font-normal text-red-600">กรุณาแนบไฟล์ใบสั่งซื้อ</small>
            }
          </div>
        </div>
        <div
          class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6"
        >
          <button
            type="button"
            class="tw-button h-11 rounded-xl border border-slate-300 bg-white px-5 text-[15px] font-semibold text-slate-700 hover:bg-slate-100"
            (click)="closeExpenseModal()"
          >
            ยกเลิก
          </button>
          <button
            type="submit"
            class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-5 text-[15px] font-semibold text-white hover:bg-[var(--theme-hover)]"
          >
            <lucide-icon name="Check" [size]="18" /> บันทึกใบขอเบิก
          </button>
        </div>
      </form>
    </section>
  </div>
}
@if (selectedExpense(); as expense) {
  <div class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]" (click)="closeExpenseDetail()">
    <section class="my-auto w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6"><div><p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">{{ expense.code }}</p><h2 class="m-0 text-xl font-bold text-slate-800">รายละเอียดใบขอเบิก</h2><div class="mt-2"><app-status-badge [status]="expense.status" /></div></div><button type="button" class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50" (click)="closeExpenseDetail()"><lucide-icon name="X" [size]="19" /></button></div>
      <div class="max-h-[68vh] overflow-y-auto p-5 sm:p-6">
        <section><h3 class="m-0 text-base font-bold text-slate-800">ข้อมูล Booking</h3><dl class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"><div><dt class="text-xs font-semibold text-slate-500">เลขที่ Booking</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.bookingCode }}</dd></div><div><dt class="text-xs font-semibold text-slate-500">ลูกค้า</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.customerName }}</dd></div><div><dt class="text-xs font-semibold text-slate-500">โปรแกรมทัวร์</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.tripName }}</dd></div><div><dt class="text-xs font-semibold text-slate-500">วันเดินทาง</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.travelDate | date: 'dd MMM yyyy' }}</dd></div><div><dt class="text-xs font-semibold text-slate-500">จำนวนผู้เดินทาง</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.travelerCount | number }} คน</dd></div><div><dt class="text-xs font-semibold text-slate-500">ยอด Booking</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.bookingTotal | number: '1.2-2' }} บาท</dd></div></dl></section>
        <section class="mt-6"><h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลรายการเบิก</h3><dl class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"><div><dt class="text-xs font-semibold text-slate-500">เลขที่ใบขอเบิก</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.code }}</dd></div><div><dt class="text-xs font-semibold text-slate-500">ผู้ขอเบิก</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.requester }}</dd></div><div><dt class="text-xs font-semibold text-slate-500">ประเภทค่าใช้จ่าย</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.expenseType }}</dd></div><div><dt class="text-xs font-semibold text-slate-500">รายการ</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.title }}</dd></div><div><dt class="text-xs font-semibold text-slate-500">วันที่สร้าง</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.createdAt | date: 'dd MMM yyyy' }}</dd></div><div><dt class="text-xs font-semibold text-slate-500">จำนวนเงิน</dt><dd class="mt-1 mb-0 font-semibold text-emerald-700">{{ expense.amount | number: '1.2-2' }} บาท</dd></div><div class="sm:col-span-2 lg:col-span-3"><dt class="text-xs font-semibold text-slate-500">ไฟล์ใบสั่งซื้อ</dt><dd class="mt-1 mb-0 font-semibold text-sky-700">{{ expense.purchaseOrderFileName }}</dd></div></dl></section>
      </div>
      <div class="flex justify-end border-t border-slate-200 bg-slate-50 px-5 py-4 sm:px-6"><button type="button" class="tw-button h-11 rounded-xl border border-slate-300 bg-white px-5 text-[15px] font-semibold text-slate-700 hover:bg-slate-100" (click)="closeExpenseDetail()">ปิด</button></div>
    </section>
  </div>
}
